import { gantt, Gantt } from "./dhtmlxgantt.commercial";

export default gantt;

export { gantt, Gantt };

